import { render, staticRenderFns } from "./FictitiousBookings.vue?vue&type=template&id=1a423a99&"
import script from "./FictitiousBookings.vue?vue&type=script&lang=js&"
export * from "./FictitiousBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports